var map = {
	"./special_0.csv": 736,
	"./special_1.csv": 737,
	"./special_2.csv": 738,
	"./special_3.csv": 739,
	"./special_4.csv": 740,
	"./special_5.csv": 741,
	"./special_6.csv": 742,
	"./special_7.csv": 743,
	"./special_8.csv": 744,
	"./special_item_list.csv": 745
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 735;


//////////////////
// WEBPACK FOOTER
// ./src/data/special ^\.\/.*\.csv$
// module id = 735
// module chunks = 0